import type { RoomClaim, Seat } from './api.ts';

export type SignalMessage =
  | { type: 'welcome'; roomId: string; seat: Seat; peers: Seat[] }
  | { type: 'peer-joined'; seat: Seat }
  | { type: 'peer-left'; seat: Seat; roomEnded: boolean }
  | { type: 'signal'; from: Seat; data: unknown }
  | { type: 'pong'; clientSend: number; serverReceive: number; serverSend: number };

export function connectSignalling(claim: RoomClaim, onMessage: (message: SignalMessage) => void): WebSocket {
  const protocol = location.protocol === 'https:' ? 'wss:' : 'ws:';
  const token = encodeURIComponent(claim.token);
  const socket = new WebSocket(`${protocol}//${location.host}/ws?token=${token}`);
  socket.addEventListener('open', () => socket.send(JSON.stringify({ type: 'hello', token: claim.token })));
  socket.addEventListener('message', (event) => {
    try {
      onMessage(JSON.parse(String(event.data)) as SignalMessage);
    } catch {
      // Malformed messages never change local state.
    }
  });
  return socket;
}

export function relaySignal(socket: WebSocket, to: Seat, data: unknown): void {
  if (socket.readyState === WebSocket.OPEN) socket.send(JSON.stringify({ type: 'signal', to, data }));
}
